import { Link } from "react-router-dom";
import ArticleCard from "@/components/feature/ArticleCard";
import { articles } from "@/mocks/articles";

export default function FeaturedSection() {
  const lead = articles[0];
  const rest = articles.slice(1, 4);

  return (
    <section className="mx-auto w-full px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <span className="flex items-center gap-2 font-label text-xs tracking-[0.2em] text-primary-600">
            <i className="ri-mic-line" aria-hidden="true"></i>
            FEATURED
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            本期重点深扒
          </h2>
        </div>
        <Link
          to="/topics"
          className="flex items-center gap-1 font-label text-sm text-foreground-700 transition-colors hover:text-primary-600"
        >
          全部内容
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <ArticleCard article={lead} variant="wide" />
        </div>
        <aside className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
          <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
            <i className="ri-list-check-2 text-primary-600" aria-hidden="true"></i>
            编辑推荐
          </h3>
          <div className="mt-3">
            {rest.map((article, index) => (
              <ArticleCard key={article.id} article={article} variant="compact" rank={index + 2} />
            ))}
          </div>
        </aside>
      </div>
    </section>
  );
}